import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import {
  beginWorkflowHistoryTransaction,
  createActionsThunk,
} from 'flow/store/redux/thunks';
import {
  findNextActionPrecedence,
  PREVIEW_OUTCOME_ACTION_NAME,
  getOutcomeBaseColor,
} from 'flow/service/actions';
import { generatePublicId } from 'flow/service/publicIds';

import type { useAppDispatch } from '~/store/reduxHooks';


export function handleOnAddOutcomeClick(
  dispatch: ReturnType<typeof useAppDispatch>,
  outcomeActions: Action[],
  isWorkflowHistoryOn: boolean,
) {
  const didBeginTransaction = dispatch(beginWorkflowHistoryTransaction({
    isWorkflowHistoryOn,
  }));
  if (!didBeginTransaction) return null;

  const publicId = generatePublicId('action', ActionType.OUTCOME);
  const name = PREVIEW_OUTCOME_ACTION_NAME;
  const precedenceIndex = findNextActionPrecedence(outcomeActions);

  dispatch(createActionsThunk({
    type: ActionType.OUTCOME,
    args: {
      publicId,
      name,
      precedenceIndex,
      color: getOutcomeBaseColor(name),
      isCaseStatus: false,
      rules: {},
      isEphemeral: false,
    },
  }));

  return publicId;
}
